// extracted by mini-css-extract-plugin
module.exports = {"matchStatsContainer":"_d6ace4f"};